import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import IndexList from '../../../lib/ui/IndexControl'
import OrganisationForm from '../ui/OrganisationForm'
import LogentryModel from '../../logentry/model/LogentryModel'
import OrganisationModel from '../model/OrganisationModel'
import ObjectTypeMapping from '../../constants/ObjectTypeMapping'

export default class EditOrganisation {
  constructor (element, args) {
    this.onchange = () => {
      this.data = this.organisationForm.getValue()
      window.PRIM.initDelayedNavigation()
      window.PRIM.dataAccess.put('organisations', this.data.getJSON()).then((organisation) => {
        if (!window.PRIM.isDelayedNavigationActive())
        {
          return
        }

        if (args && !args.id && organisation.id) {
          window.PRIM.navigate('/organisations/' + organisation.id, true)
        }

        if (organisation) {
          this.data.values.id = organisation.id
          this.organisationForm.setValue(this.data)
        }        
      })
    }

    if (args && args.id) {
      window.PRIM.dataAccess.resolve('organisations', args.id, true).then((organisation) => {
        this.data = organisation
        this.organisationForm.setValue(this.data)

        window.PRIM.dataAccess.resolve('locations', this.data.values.id, true, 'organisation_id').then((locations) => {
          for (let i = 0; i < locations.length; i++) {
            if (locations[i].values.id === this.data.values.location_id) {
              this.data.location = locations[i]
              this.organisationForm.setValue(this.data)
              break
            }
          }

          this.data.locations = locations
          this.locationIndex.setItems(this.data.locations)
        }, () => {
        }).catch(() => {
        })

        window.PRIM.dataAccess.get('logentries').then((logentries) => {
          let results = logentries.filter((logentry) => {
            return logentry.target_id === this.data.values.id && logentry.object_type_id === ObjectTypeMapping.organisation
          })

          this.data.logentries = results.map((logentry) => {
            return new LogentryModel(logentry)
          })

          this.logIndex.setItems(this.data.logentries)
        }, () => {
        }).catch(() => {
        })
      }, () => {
        if (confirm('Deze organisatie bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuwe organisatie aanmaken?')) {
          window.PRIM.navigate('/organisations/')
        } else {
          history.back()
        }
      }).catch(() => {
      })
    }

    this.data = new OrganisationModel()

    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Organisatie bewerken',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      },
        {
          onclick: () => {
            history.forward()
          },
          icon: '\ue01a'
        },
        {
          onclick: () => {
            window.PRIM.navigate('/start/')
          },
          icon: '\ue08a'
        },
        {
          onclick: this.onchange,
          icon: '\ue020',
          classes: 'indicator'
        }],
      contextMenu: [
        {
          onclick: () => {
            if (this.data.values.id) {
              window.PRIM.navigate('/locations/new/' + this.data.values.id)
            } else {
              alert('Vul eerst gegevens voor deze organisatie.')
            }
          },
          icon: '\ue0a0',
          label: 'Vestiging'
        },
        {
          onclick: () => {
            if (this.data.values.id) {
              window.PRIM.navigate('/logentries/organisation/' + this.data.values.id)
            } else {
              alert('Vul eerst gegevens voor deze organisatie.')
            }
          },
          icon: '\ue032',
          label: 'Logboekregel'
        },
        {
          onclick: () => {
            if (this.data.values.id) {
              if (confirm('Weet u het zeker dat u deze organisatie wilt verwijderen?')) {
                window.PRIM.dataAccess.delete('organisations', this.data.values.id).then(() => {
                  history.back()
                })
              }
            } else {
              alert('Vul eerst gegevens voor deze organisatie.')
            }
          },
          icon: '\ue123',
          label: 'Verwijderen'
        }
      ]
    })

    let div = document.createElement('div')
    div.className = 'viewport'

    let divContent = document.createElement('div')
    divContent.className = 'content'

    let primaryData = document.createElement('section')
    primaryData.className = 'primary'
    let secondaryData = document.createElement('section')
    secondaryData.className = 'secondary'

    this.organisationForm = new OrganisationForm(primaryData, {organisation: this.data, onchange: this.onchange})

    let fieldsetLocations = document.createElement('fieldset')
    let legendLocations = document.createElement('legend')
    legendLocations.innerHTML = 'Vestigingen'
    fieldsetLocations.appendChild(legendLocations)

    let onclickLocation = (item) => {
      window.PRIM.navigate('/locations/' + item.values.id)
    }

    this.locationIndex = new IndexList(fieldsetLocations, {items: this.data.locations, onclick: onclickLocation})

    secondaryData.appendChild(fieldsetLocations)

    let fieldsetLog = document.createElement('fieldset')
    let legendLog = document.createElement('legend')
    legendLog.innerHTML = 'Logboek'
    fieldsetLog.appendChild(legendLog)

    let onclickLogentry = (item) => {
      window.PRIM.navigate('/logentries/' + item.values.id)
    }

    this.logIndex = new IndexList(fieldsetLog, {items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry})

    secondaryData.appendChild(fieldsetLog)

    divContent.appendChild(primaryData)
    divContent.appendChild(secondaryData)
    div.appendChild(divContent)
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/organisation/action/EditOrganisation.js